import { DonationConfirmationSheetComponent } from './../../../donation-confirmation/components/donation-confirmation-sheet/donation-confirmation-sheet.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ICurrency } from '../../../../shared/models/currency.model';
import { PaymentUtilService } from '../../services';
import { EventsService, UtilService, VariablesService, VwoService } from '../../../../shared/services';
import { IFundraiser } from '../../../../fundraiser/models/fundraiser.model';
import {
  DonationConfirmationComponent
} from '../../../donation-confirmation/components/donation-confirmation/donation-confirmation.component';

@Component({
  selector: 'app-payment-header',
  templateUrl: './payment-header.component.html',
  styleUrls: ['./payment-header.component.scss']
})
export class PaymentHeaderComponent implements OnInit {
  @Input() public fundraiser: IFundraiser;
  @Input() isReward;
  @Input() selectedCurrency;
  @Input() screenName;
  @Input() showBeneficiary;
  @Input() contributeDetails;
  @Input() isStandAlone;
  @Input() type = 'v1';
  @Input() tiptyp;
  @Output() userSelectionCurrency: EventEmitter<ICurrency> = new EventEmitter();
  supportedCurrencies: ICurrency[];
  currency;
  params;
  currentUrl;
  isMobile;
  constructor(
    private paymentUtilService: PaymentUtilService,
    public util: UtilService,
    public location: Location,
    private actRoute: ActivatedRoute,
    public dialog: MatDialog,
    public router: Router,
    public vars: VariablesService,
    private bottomSheet: MatBottomSheet,
    public vwo: VwoService,
    public events: EventsService
  ) { }

  ngOnInit() {
    this.isMobile = this.util?.isMobile();
    this.getCurrencyDetails();
    this.actRoute.queryParams.subscribe((params) => {
      this.params = params;
    });
  }
  /**Get the details of the currency */
  getCurrencyDetails() {
    this.paymentUtilService.supportedCurrencies.subscribe({
      next: (res) => {
        if (res) {
          setTimeout(() => {
            this.supportedCurrencies = res;
          }, 0);
        }
      }
    });
    this.paymentUtilService.paymentCurrency.subscribe({ next: (res) => this.currency = res });
  }
  /**Get the title */
  getTitle(param, op) {
    if (op && this.util.isMobile()) {
      // if (!this.vwoService.paymentV2AB) {
        switch (op) {
          case 'c': return this.util.isMobile() ? '' : 'Enter your card details';
          case 'p': return 'Payment using PayTM';
        }
      // } else {
      //   switch (op) {
      //     case 'CARD': return 'Cards';
      //     case 'UPI': return 'UPI';
      //     case 'NB': return 'Net Banking';
      //     case 'WALLET': return 'Wallets';
      //   }
      // }
    } else {
      switch (param) {
        case 'rd':
          return 'Choose Reward amount';
        case 'form':
          return 'Choose a contribution amount';
        case 'options':
          return 'Choose payment option';
      }
    }
  }
  /**Get emited currency fromheader and set it */
  setCurrency(currency: ICurrency) {
    this.paymentUtilService.paymentCurrency.next(currency.currency);
    this.userSelectionCurrency.emit(currency);
  }
  /**Back action of payment header */
  back() {
    const params = { ...this.actRoute.snapshot.queryParams };
    if (params?.st === 'f' && params?.frtip && this.vars.pageName === 'thank_you') {
      this.dialog.closeAll();
      return
    }
    if (this.isMobile && this.vars.pageName.match('mini_story') && params?.payment === 'options') {
      this.vars.paymentFormAction.next('closed');
      this.dialog.closeAll();
      this.router.navigate([], { queryParams: { st: null, payment: 'form', op: null }, queryParamsHandling: 'merge' });
      return;
    }
    if (params?.st === 'f' && params?.payment === 'options' && this.vars.showKCart && ((!this.util.isMobile() && this.vars.pageName.match('stories|mini_story')) || (this.util.isMobile() && !this.vars.pageName.match('stories|mini_story')))) {
      this.router.navigate([], { queryParams: { payment: 'form' }, queryParamsHandling: 'merge' });
      this.screenName = 'form';
      return
    } else if (params?.st === 'f' && params?.payment === 'options') {
      this.router.navigate([], { queryParams: { payment: 'form', op: null }, queryParamsHandling: 'merge' });
      this.screenName = 'form';
      return
    } else if (params?.st === 'f' && params?.payment === 'options' && this.util.isMobile() && (this.vars.pageName.match('stories|mini_story') || this.vars.showStoryOnFundraiser)) {
      this.router.navigate([], { queryParams: { payment: 'form' }, queryParamsHandling: 'merge' });
      this.screenName = 'form';
      return;
    }

    if (this.screenName === this.params.payment && !this.params.op && !this.isStandAlone) {
      if (!this.util.isMobile() && !this.tiptyp) {
        const dialogRef = this.dialog.open(DonationConfirmationComponent, {
          data: { contributeDetails: this.contributeDetails, currency: this.currency },
          width: '100%',
          height: 'auto',
          maxWidth: '500px',
          maxHeight: '536px',
          panelClass: 'confirmation-modal'
        });
        dialogRef.componentInstance.cancelPayment.subscribe(() => {
          this.vars.paymentFormAction.next('closed');
          if (this.isStandAlone) {
            this.location.back();
          } else if (!this.vars.pageName.match('stories|mini_story')) {
            this.router.navigate([], { queryParams: { st: null }, queryParamsHandling: 'merge' });
          }
        });
      } else if (this.util.isMobile() && !this.tiptyp) {
        const bottomSheetRef = this.bottomSheet.open(DonationConfirmationSheetComponent, {
          data: { contributeDetails: this.contributeDetails, currency: this.currency },
          panelClass: 'confirmation-modal-sheet'
        });
        bottomSheetRef.afterDismissed().subscribe((val) => {
          this.vars.paymentFormAction.next('closed');
          if (this.isStandAlone) {
            this.location.back();
          } else if (!this.vars.pageName.match('stories|mini_story')) {
            this.router.navigate([], { queryParams: { st: null }, queryParamsHandling: 'merge' });
          } else if (this.vars.pageName.match('mini_story')) {
            this.location.back();
          }
        });
      } else {
        this.dialog.closeAll();
        if (this.isStandAlone) {
          this.location.back();
        }
      }
      const payload = {
        eventName: 'exitIntent_back',
        page_name: this.vars.pageName,
      }
      this.events.sendSystemEvent(payload).subscribe(_ => _);
    } else if (this.params?.st === 'f' && this.params?.payment === 'options' && !this.params?.op && this.isStandAlone) {
      this.router.navigate([], { queryParams: { payment: 'form' }, queryParamsHandling: 'merge' });
    } else {
      this.location.back();
      this.paymentUtilService.backButton.next(this.params);
      this.paymentUtilService.cartSubs.forEach(s => s.unsubscribe());
    }
  }

}
